import { Center, Text, CenterProps } from '@chakra-ui/react';

type NormalProps = { day: number } & CenterProps;

export default function Normal({ day, ...props }: NormalProps) {
  return (
    <Center
      role="group"
      cursor="pointer"
      borderRadius="5px"
      borderWidth="1px"
      borderColor="gray.200"
      py={4}
      _hover={{
        bgColor: 'primary',
        borderColor: 'primary',
      }}
      {...props}
    >
      <Text
        fontWeight="bold"
        _groupHover={{
          color: 'white',
        }}
      >
        {day}
      </Text>
    </Center>
  );
}
